// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Advantages_wrapper__gMj0m","wrapperCard":"Advantages_wrapperCard__JoBK6","image":"Advantages_image__82Pwq","subtitle":"Advantages_subtitle__AsF2S"};